import { Component } from 'react';
import cx from 'classnames';
import styles from '../../styles/common/actionMenu.scss';

interface State {
  showMenu: boolean;
}

class ActionMenu extends Component<any, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      showMenu: false,
    };
  }

  public componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick);
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  private handleOutsideClick = (e: any) => {
    const { id } = e.target;
    const { itemId } = this.props;
    if (id !== `action-menu-${itemId}` && id !== `menu-trigger-${itemId}`) {
      this.setState({
        showMenu: false,
      });
    }
  };

  private handleMenuItemClick = (e: any) => {
    const { id } = e.currentTarget;
    const { action } = e.target.dataset;
    e.preventDefault();
    if (id === `action-menu-${this.props.itemId}`) {
      e.stopPropagation();
      this.props.handleActionClick(action, e);
    }
  };

  private toggleShowMenu = (e: any) => {
    e.stopPropagation();
    const { id } = e.currentTarget || e.target;
    if (id === `menu-trigger-${this.props.itemId}`) {
      this.setState({
        showMenu: !this.state.showMenu,
      });
    }
  };

  public render() {
    const { showMenu } = this.state;
    const { itemId, actions, className, isNfo } = this.props;
    return (
      <div className={cx(className, styles['actionmenu-wrapper'])}>
        <span
          className={cx(
            styles['menu-trigger'],
            'text--xmd font--bold cursor--pointer',
            {
              [styles.active]: showMenu,
            }
          )}
          id={`menu-trigger-${itemId}`}
          onClick={this.toggleShowMenu}
        >
          <span id={`menu-trigger-${itemId}`} />
          <span id={`menu-trigger-${itemId}`} />
          <span id={`menu-trigger-${itemId}`} />
        </span>

        {showMenu ? (
          <div
            id={`action-menu-${itemId}`}
            className={styles['action-menu']}
            onClick={this.handleMenuItemClick}
          >
            <ul>
              {actions.map(action => {
                const isDelete = action.label === 'Delete';
                if (
                  (action.label === 'Invest more' ||
                    action.label === 'Redeem') &&
                  isNfo
                ) {
                  return null;
                } else {
                  return (
                    <li key={action.key}>
                      <a
                        data-action={action.key}
                        className={cx('text--md font--hover--bold', {
                          'mobile-only--display': action.mobileOnly,
                          hide: action.hide,
                          'font--red': isDelete,
                        })}
                        href="#"
                      >
                        {action.icon && (
                          <img
                            className="verticle-align-top mr5 inline"
                            src={action.icon}
                          />
                        )}
                        {action.label}
                      </a>
                    </li>
                  );
                }
              })}
            </ul>
          </div>
        ) : null}
      </div>
    );
  }
}

export default ActionMenu;



// WEBPACK FOOTER //
// ./components/common/actionMenu.tsx